import {
  userRolesType,
  forgerockRoleKey,
  forgerockCashplanRoleKey,
  userRoles,
  cashplanRoleScope,
} from "../../types/enums/User/Roles";
import { applications } from "../../types/applications";

export const roleCheck = (
  requiredRoles: userRolesType[],
  userRoles: userRolesType[],
  allRolesRequired = false,
) => {
  let foundRoles = 0;
  requiredRoles.forEach((rRole) => {
    if (userRoles.includes(rRole)) {
      foundRoles = foundRoles + 1;
    }
  });

  if (allRolesRequired) {
    return foundRoles === requiredRoles.length;
  }
  return foundRoles > 0;
};

export const getRoleFromAttribute = (
  att?: string,
): userRolesType | undefined => {
  if (!att) {
    return undefined;
  }
  switch (att) {
    case `${forgerockRoleKey}:${userRoles.normal}`:
      return userRoles.normal;
    case `${forgerockRoleKey}:${userRoles.admin}`:
      return userRoles.admin;
    case `${forgerockRoleKey}:${userRoles.super}`:
      return userRoles.super;
    case `${forgerockRoleKey}:${userRoles.enhanced}`:
      return userRoles.enhanced;
    case `${forgerockCashplanRoleKey}:${cashplanRoleScope}`:
      return userRoles.cashplan;
    case `${forgerockRoleKey}:${userRoles.helpAtHandSSO}`:
      return userRoles.helpAtHandSSO;
    case `${forgerockRoleKey}:${userRoles.helpAtHandMi}`:
      return userRoles.helpAtHandMi;
    default:
      return undefined;
  }
};

export const getRolesFromAttributes = (attList?: string[]): userRolesType[] => {
  if (!attList) {
    return [];
  }
  return attList
    .map((role) => getRoleFromAttribute(role))
    .filter((role) => role !== undefined);
};

export const getGroupProtectionRole = (
  attList?: string[],
): userRolesType | undefined => {
  return getRolesFromAttributes(attList).find(
    (role) =>
      role === userRoles.admin ||
      role === userRoles.super ||
      role === userRoles.enhanced ||
      role === userRoles.normal,
  );
};

export const checkAppAccess = (
  usersAccess: applications[],
  requiredAccess: applications[],
  allRolesRequired = true,
) => {
  const foundRoles = requiredAccess.filter((role) =>
    usersAccess.includes(role),
  );

  return allRolesRequired
    ? foundRoles.length === requiredAccess.length
    : foundRoles.length > 0;
};
